import * as React from "react";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";

import { TaskActionButton } from "../TaskActionButton";

interface Props {
    task: TaskModel;
}

export const ActionFurtherInformationAndReviewOfFitnessButton: React.FunctionComponent<Props> = (props: Props) => {
    if (props.task.completed) {
        return null;
    }

    return (
        <TaskActionButton
            task={props.task}
            customerId={props.task.customer.id}
            content="Action Task"
            taskRoute="review-of-fitness"
        />
    );
};
